// get product discount price
export const getDiscountPrice = (price:any, discount:any) => {
  return discount && discount > 0 ? (price - price * (discount / 100)).toFixed(2) : price;
}

// get products
export const getProducts = (products:any, limit:any, type?:any, category?:any) => {
    const finalProducts = category ? products.filter( (product:any) => product.category.filter((single:any) => single === category)[0] ) : products;
    
    if(!finalProducts) return null;
    const prodArray = [...finalProducts]

    if (type && type === "bestSeller") {
        return prodArray.sort((a, b) => b.saleCount - a.saleCount).slice(0, limit ? limit : finalProducts.length)
    }
    return finalProducts.slice(0, limit ? limit : finalProducts.length);
}